export const SET_FUNNEL_UI_FLAG = 'SET_FUNNEL_UI_FLAG';
export const CLEAR_FUNNELS = 'CLEAR_FUNNELS';
export const SET_FUNNELS = 'SET_FUNNELS';
export const SET_FUNNEL_ITEM = 'SET_FUNNEL_ITEM';
export const EDIT_FUNNEL = 'EDIT_FUNNEL';
export const DELETE_FUNNEL = 'DELETE_FUNNEL';
export const SET_FUNNEL_CONTACTS = 'SET_FUNNEL_CONTACTS';
export const UPDATE_FUNNEL_CONTACT = 'UPDATE_FUNNEL_CONTACT';
export const REMOVE_FUNNEL_CONTACT = 'REMOVE_FUNNEL_CONTACT';
